/* @flow */

const assetRoutes = {
  scheduleCalibration: 'assets/request-calibration-schedule',
  reportFault: 'assets/request-fault-report',
  enable: 'accounts/:accountGuid/enable-disable',
  archiveAsset: 'assets/:assetGuid/archive',
  byUserAndLocation: '/assets/account/:accountGuid/user/:userGuid/location/:locationGuid',
  byUserAndCompany: '/assets/account/:accountGuid/user/:userGuid/company/:companyGuid',
  locations: '/assets/location/:locationGuid',
  activity: 'assets/:assetGuid/activity',
};

export default assetRoutes;
